import { global_hooks } from 'src/globals';

global_hooks.on('init', init);
function init() {
	const container = document.querySelector('.mega_menu_init_con');
	if (!container?.children[0]) return;
	import('./mega_menus');
}

elementor_edit_screen_load_css();
function elementor_edit_screen_load_css() {
	if (!document.body.classList.contains('elementor-page-2006')) return;
	import('./mega_menu.scss');
}
